import { Calendar, Gift, Globe, Info, Mail, MonitorDot, Settings, ShoppingBag, UserRound, UsersRound } from "lucide-react";

const menuData: any = [
  {
    label: 'menu',
    isTitle: true,
    role: ['dashboard']
  },
  {
    id: "dashboard",
    label: 'Dashboards',
    link: "/#",
    icon: <MonitorDot />,
    role: ['dashboard']
  },
  {
    label: 'Maintenance',
    isTitle: true,
  },
  {
    id: "ecommerce",
    label: 'Ecommerce',
    link: "/#",
    icon: <ShoppingBag />,
    role: ['ecommerce','custom'],
    subItems: [
      {
        id: 'product',
        label: 'Products',
        parentId: 'ecommerce',
        link: '/apps-ecommerce-product-list',
        otherLinks: ['/apps-ecommerce-product-update','/apps-ecommerce-product-create'],
        role: ['ecommerce'],
      },
      {
        id: 'order',
        label: 'Orders',
        link: '/apps-ecommerce-orders',
        parentId: 'ecommerce',
        role: ['ecommerce'],
      },
      {
        id: 'ordercustom',
        label: 'Custom Orders',
        link: '/apps-ecommerce-custom-orders',
        parentId: 'ecommerce',
        role: ['custom'],
      },
      {
        id: 'product',
        label: 'Product Category',
        parentId: 'maintenances',
        link: '/maint-product-category',
        role: ['ecommerce'],
      },
    ]
  },
  {
    id: "booking",
    label: 'Booking',
    link: "/#",
    icon: <Calendar />,
    role: ['booking'],
    subItems: [
      {
        id: 'booking',
        label: 'Bookings',
        parentId: 'booking',
        link: '/apps-booking',
        role: ['booking'],
      },
      {
        id: 'service',
        label: 'Services',
        link: '/apps-booking-services',
        parentId: 'booking',
        role: ['booking'],
      },
      {
        id: 'service-type',
        label: 'Service Categories',
        link: '/apps-service-type',
        parentId: 'booking',
        role: ['booking'],
      },
      {
        id: 'customform',
        label: 'Custom Forms',
        link: '/apps-service-custom-form',
        parentId: 'booking',
        role: ['booking'],
      }
    ]
  },
  {
    id: "reward",
    label: 'Reward',
    link: "/#",
    icon: <Gift />,
    role: ['reward'],
    subItems: [
      {
        id: 'reward-point',
        label: 'Reward Point',
        parentId: 'reward',
        link: '/apps-reward-point',
        role: ['reward'],
      },
    ]
  },
  {
    id: "maintenances",
    label: 'Maintenances',
    link: "/#",
    icon: <Settings />,
    subItems: [
      {
        id: 'campaign',
        label: 'Campaign',
        parentId: 'maintenances',
        link: '/maint-campaign',
      },
      {
        id: 'promo',
        label: 'Promo',
        parentId: 'maintenances',
        link: '/maint-promo',
      },
    ]
  },
  {
    id: 'projects',
    label: 'Projects',
    icon: <Globe />,
    link: '/project',
    parentId: 2,
    role: ['project'],
  },
  {
    id: 'users',
    label: 'Users',
    icon: <UserRound />,
    link: '/users-list',
    parentId: 2,
    role: ['user'],
  },
  {
    id: 'customers',
    label: 'Customers',
    icon: <UsersRound />,
    link: '/customers',
    role: ['customer'],
  },
  {
    id: 'notification',
    label: 'Notification',
    icon: <Mail />,
    link: '/notification-list',
    parentId: 2,
    role: ['notification'],
  },
  {
    id: 'setting',
    label: 'Setting',
    icon: <Settings />,
    link: '/setting',
    parentId: 2,
    role: ['customer'],
  },
  {
    id: 'about-us',
    label: 'About Us',
    icon: <Info />,
    link: '/about-us',
    role: ['customer'],
  },
];

export { menuData };